import React from 'react'

interface CallProgressBarProps {
  progressRatio: number
  isVoicemail?: boolean
}

const CallProgressBar: React.FC<CallProgressBarProps> = ({
  progressRatio,
  isVoicemail = false,
}) => {
  // progress bar for both calls and voicemails
  return (
    <div
      className="position-relative"
      style={{
        height: '8px',
        cursor: 'pointer',
        width: '100%',
        borderRadius: '4px',
        backgroundColor: '#4A5568',
      }}
    >
      <div
        className="position-absolute"
        style={{
          height: '8px',
          width: `${progressRatio * 100}%`,
          borderRadius: '4px',
          backgroundColor: isVoicemail ? '#e91e63' : '#4ea6ff',
          top: '0',
          left: '0',
        }}
      />
      <div
        className="position-absolute bg-white rounded-circle"
        style={{
          width: 'clamp(16px, 4vw, 20px)',
          height: 'clamp(16px, 4vw, 20px)',
          top: '50%',
          left: `${progressRatio * 100}%`,
          transform: 'translate(-50%, -50%)',
        }}
      />
    </div>
  )
}

export default CallProgressBar
